import React, { useEffect } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import '../styles/Lightbox.css';

const Lightbox = ({ photo, onClose }) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <Modal
      isOpen={true}
      toggle={onClose}
      className="lightbox-modal"
      backdrop="static"
      keyboard={true}
      onClick={handleBackdropClick}
      fullscreen={true}
    >
      <ModalBody className="lightbox-body">
        <button className="lightbox-close" onClick={onClose}>
          ×
        </button>
        <div className="lightbox-content">
          <img
            src={photo.original}
            alt={photo.filename}
            className="lightbox-image"
            style={{
              maxWidth: '100%',
              maxHeight: '100vh',
              objectFit: 'contain'
            }}
          />
        </div>
      </ModalBody>
    </Modal>
  );
};

export default Lightbox;